import { NgModule } from '@angular/core';
import { PhoneNumberComponent } from './phone-number.component';
import { PhoneNumberService } from './phone-number.service';

@NgModule({
  imports: [PhoneNumberComponent],
  exports: [PhoneNumberComponent],
  providers: [PhoneNumberService]
})
export class PhoneNumberModule {}
